import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z" fill="#000" fillOpacity=".4" /><path d="M11.25 9v12L21 15l-9.75-6z" fill="currentColor" /></svg>);